import React, { useState } from 'react';
import Button from '../../ui/Button';
import { Filter, Download, CheckSquare, Layers, AlertTriangle } from 'lucide-react';

const HistoryToolbar = ({ 
  selectedCount = 0, 
  loadedCount = 0,
  totalCount = 0,
  onBulkDownload, 
  onToggleFilters, 
  showFilters, 
  hasFilters,
  onLoadAll,
  onSelectAll,
  allSelected
}) => {
  const [showLoadModal, setShowLoadModal] = useState(false);

  const handleLoadClick = () => {
    if (totalCount > 500) {
      alert("Не можете да заредите над 500 фактури наведнъж. Моля, използвайте филтрите, за да стесните търсенето.");
      return;
    }
    if (totalCount > 300) {
      setShowLoadModal(true);
      return;
    }
    onLoadAll();
  };

  const confirmLoad = () => {
    setShowLoadModal(false);
    onLoadAll();
  };

  return (
    <div className="px-4 sm:px-6 py-4 flex flex-col sm:flex-row gap-4 justify-between items-center bg-white border-b border-gray-100">
      <div className="flex flex-col">
        <div className="text-[13px] font-medium text-gray-500">
          Показани: <span className="text-gray-900 font-bold">{loadedCount}</span> от <span className="text-gray-900 font-bold">{totalCount}</span>
        </div>
        {onSelectAll && (
          <div className="text-[13px] font-medium text-gray-500">
            Избрани: <span className="text-gray-900 font-bold">{selectedCount}</span>
          </div>
        )}
      </div>
      <div className="flex gap-3">
        {hasFilters && (
          <Button 
            variant={showFilters ? "primary" : "secondary"} 
            className={`text-[13px] px-4 flex items-center gap-2 ${!showFilters ? 'border-gray-200' : ''}`}
            onClick={onToggleFilters}
          >
            <Filter size={16} />
            Филтри
          </Button>
        )}
        
        {loadedCount < totalCount && (
          <Button 
            variant="secondary" 
            className="text-[13px] px-4 flex items-center gap-2 border-gray-200"
            onClick={handleLoadClick}
          >
            <Layers size={16} />
            Зареди всички
          </Button>
        )}

        {onSelectAll && (
          <Button 
            variant="secondary" 
            className="text-[13px] px-4 flex items-center gap-2 border-gray-200"
            onClick={onSelectAll}
            disabled={loadedCount === 0}
          >
            <CheckSquare size={16} />
            {allSelected ? 'Отмаркирай всички' : 'Избери всички'}
          </Button>
        )}

        {onBulkDownload && (
          <Button 
            variant="secondary" 
            className="text-[13px] px-4 flex items-center gap-2 border-gray-200"
            disabled={selectedCount === 0}
            onClick={onBulkDownload}
          >
            <Download size={16} />
            Изтегли PDF
          </Button>
        )}
      </div>

      {showLoadModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            <div className="px-6 py-6 border-b border-gray-100 flex gap-4">
              <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                <AlertTriangle className="text-orange-600" size={20} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Зареждане на голям брой данни</h3>
                <p className="text-[14px] text-gray-500 leading-relaxed">
                  Опитвате се да заредите <strong>{totalCount}</strong> фактури. Тази операция може да отнеме повече време и да забави браузъра ви.
                  Сигурни ли сте, че искате да продължите?
                </p>
              </div>
            </div>
            <div className="px-6 py-4 bg-gray-50 flex justify-end gap-3">
              <Button variant="secondary" onClick={() => setShowLoadModal(false)} className="text-[13px] px-5">
                Отказ
              </Button>
              <Button variant="primary" onClick={confirmLoad} className="text-[13px] px-5 bg-orange-600 hover:bg-orange-700 border-orange-600 hover:border-orange-700 shadow-sm text-white">
                Да, зареди всички
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HistoryToolbar;
